import { NotificationOptions } from '../../../models/notification.model'

export type ViewNotificationCode =
  | 'COLUMN_ALREADY_PRESENT'
  | 'VIEW_INCOMPLETE'
  | 'VIEW_SAVED'
  | 'VIEW_DELETED'

/**
 * Parse goods return code to a notification
 * @param code - the goods return notification code
 * @returns the notification options
 */
export function ngParseViewNotification(
  code?: ViewNotificationCode,
): NotificationOptions {
  switch (code) {
    case 'COLUMN_ALREADY_PRESENT':
      return {
        message: 'The selected column is already present',
        color: 'error',
      }
    case 'VIEW_SAVED':
      return {
        message: 'View saved successfully',
        color: 'success',
      }
    case 'VIEW_INCOMPLETE':
      return {
        title: 'Attention',
        message: 'Fill out the form with all the necessary data',
        color: 'error',
      }
    case 'VIEW_DELETED':
      return {
        message: 'View deleted successfully',
        color: 'success',
      }

    default:
      return {}
  }
}
